import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import withIntl from '../../../../components/Intl/WithIntl';
import { ButtonGroup, Button, Form, FormGroup, InputGroup, Input, Alert, UncontrolledCollapse, Label } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Toggle from '../../../../components/Form/Toggle';

import config from '../../../../config';
import { storagePersistent as storage } from '../../../../util/storage';
import { dateFormat } from '../../../../util/date';

import { checkUserAccountRequest, forgetPasswordRequest, loginUserRequest, USER_AUTH_USER_HASH } from '../../AuthActions';
import { setRedirect } from '../../../App/AppActions';
import { displayErrors } from '../../../Error/ErrorActions';

import withRouter from '../../../../components/Router/WithRouter';
import UserNewPassword from './UserNewPassword';
import UserVerificationCheck from './UserVerificationCheck';
import Chrono from '../../../../components/Time/Chrono';

class UserLoginForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            step: 'identifier',
            displayForgotPasswordButton: false,
            displayClearPassword: false,
            displayAccountCheckError: false,
            isOnLogin: false,
            identifier: props.search.identifier || '',
            password: props.search.password || '',
            userHash: '',
            activationCode: props.search.activation || '',
            activation: null,
            verification: null,
            isAccountActivated: false,
            attempts: 0,
            // lastAttempt: '',
            isBlocked: false,
            isUnknowUser: false,
            rememberMyDevice: false,
            displayDataTreatmentLegalInfo: false,
        };
    }

    componentDidMount() {
        // if(this.props.location && this.props.search && this.props.search.sso_username && this.props.search.sso_refresh) { // TODO: Still used ???
        //     this.handleLoginWithToken(this.props.search.sso_username, this.props.search.sso_refresh);
        // // } else if(this.props.identifier && this.props.password) {
        // //     this.handleLogin(new Event('autoLogin'));
        // } else
        if(!this.state.identifier && storage && storage.getItem(USER_AUTH_USER_HASH)) {
            this.goToPasswordStep();
        }
    }

    handleChange = event => {
        const { target } = event;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const { name } = target;
        this.setState({
            [name]: value,
        });
    };

    hasErrorField = name => {
        return this.state.errorFields && this.state.errorFields.indexOf(name) !== -1;
    };

    goToPasswordStep = () => {
        this.setState({
            userHash: storage.getItem(USER_AUTH_USER_HASH) || '',
            step: 'password',
        }, () => {
            if(this.state.password) {
                this.handleLogin();
            } else if(this.state.identifier || this.state.userHash) {
                this.handleCheckAccount();
            }
        });
    };

    handleClearIdentifier = () => {
        storage.removeItem(USER_AUTH_USER_HASH);
        this.setState({
            step: 'identifier',
            identifier: '',
            userHash: '',
        });
    };

    handleCheckAccount = event => {
        event && event.preventDefault();
        this.props.dispatch(checkUserAccountRequest(this.state.userHash || this.state.identifier, !!this.state.activationCode, !!this.state.userHash)).then(result => {
            if(result && result.ok) {
                this.setState({
                    identifier: result.identifier || this.state.identifier,
                    step: result.activation ? 'activation' : 'password',
                    activation: result.activation,
                    isAccountActivated: !result.activation,
                    displayAccountCheckError: result.check && this.props.search.accountcheck && result.check !== this.props.search.accountcheck,
                    displayNewPassword: !!this.state.activationCode && result.activation,
                });
                this.state.rememberMyDevice && storage && storage.setItem(USER_AUTH_USER_HASH, result.userHash);
            } else {
                // Do not display error on identifier check => Display password step instead
                // displayErrors('error', this.props.intl.formatMessage({ id: 'userAccountNotExistsAlert', defaultMessage: 'No existing account with your idenfier!' }));
                this.setState({
                    step: 'password',
                    isUnknowUser: true,
                });
            }
        });
    };

    handleLogin = (event, verificationKey = '') => {
        event && event.preventDefault();
        if(this.state.identifier && this.state.password && !this.state.isUnknowUser) {
            this.setState({
                isOnLogin: true,
                attempts: this.state.attempts + 1,
                // lastAttempt: moment.utc().format(),
            });
            this.props.dispatch(loginUserRequest(this.state.identifier, this.state.password, verificationKey)).then(result => {
                if(result) {
                    // Success: credentials are ok
                    this.setState({
                        isOnLogin: false,
                        step: result.verification?.strategy ? 'verification' : 'confirmation',
                        verification: result.verification,
                        displayForgotPasswordButton: !result.verification,
                    }, () => {
                        if(this.state.step === 'confirmation') {
                            this.props.onLogin
                            ? this.props.onLogin()
                            : this.props.dispatch(setRedirect(this.props.appRedirect || this.props.redirect || '/'));
                        }
                    });
                } else {
                    displayErrors('error', this.props.intl.formatMessage({
                        id: 'userLoginError',
                        defaultMessage: 'Wrong credentials! Please retry...',
                    }));
                    this.setState({
                        displayForgotPasswordButton: true,
                        isOnLogin: false,
                    });
                }
            }).catch(err => {
                this.setState({
                    step: this.state.activationCode || this.state.attempts > 1 ? 'identifier' : 'password',
                    isOnLogin: false,
                    isBlocked: this.state.attempts % 5 === 0,
                    displayForgotPasswordButton: this.state.attempts > 1,
                    password: '',
                    activationCode: '',
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            isBlocked: false,
                        });
                    }, 60 * 1000);
                });

                displayErrors('error', this.props.intl.formatMessage({
                    id: 'userLoginError',
                    defaultMessage: 'Wrong credentials! Please retry...',
                }));
            });
        } else {
            const errorFields = [];
            if(!this.state.identifier) {
                errorFields.push('identifier');
            }
            if(!this.state.password) {
                errorFields.push('password');
            }
            this.setState({
                errorFields,
                step: this.state.isUnknowUser ? 'identifier' : 'password',
            });

            this.state.isUnknowUser && displayErrors('error', this.props.intl.formatMessage({
                id: 'userLoginError',
                defaultMessage: 'Wrong credentials! Please retry...',
            }));
        }
    };

    handleLoginWithVerification = verificationResult => {
        return this.handleLogin(null, verificationResult?.key);
    };

    handleForgotPassword = () => {
        return this.props.dispatch(forgetPasswordRequest(this.state.identifier)).then(result => {
            this.setState({
                hasForgottenPassword: true,
                step: 'verification',
                verification: result?.verification,
            });
        });
    };

    handleForgottenPassword = verificationResult => {
        return this.props.dispatch(forgetPasswordRequest(this.state.identifier, verificationResult?.key)).then(isOk => {
            isOk && this.handleCheckAccount();
        });
    };

    render() {
        if(this.state.displayNewPassword) {
            return <UserNewPassword identifier={this.state.identifier} activationCode={this.state.activationCode} redirect={this.props.redirect} closeForm={(isActivated, password) => (isActivated ? this.setState({ password, displayNewPassword: false }, this.handleLogin) : this.setState({ displayNewPassword: false }))} />;
        }

        return (
            <div>
                {['identifier', 'password'].includes(this.state.step) && (
                    <div className="mb-5 text-center">
                        <h5>
                            <FontAwesomeIcon icon="info-circle" />{' '}
                            {this.state.activationCode ? <FormattedMessage id="userAuthActivationIdentifierForm" defaultMessage="Enter your identifier to activate your account" /> : <FormattedMessage id="userLoginIntro" defaultMessage="Please login to access to your dashboard." />}
                        </h5>
                        <a href={`${config.staticUrl}help/managexam-connexion-guide.pdf`} target="_blank" className="" rel="noreferrer"><small><FormattedMessage id="userLoginHelpButton" defaultMessage="Need help? Checkout our guide" /></small></a>
                    </div>
                )}

                {this.state.step === 'identifier' && (
                    <Form onSubmit={this.handleCheckAccount}>
                        <FormGroup className={this.hasErrorField('identifier') ? 'has-danger text-danger' : ''}>
                            <Label for="identifierField"><FormattedMessage id="userIdentifier" defaultMessage="Personnal identifier" /></Label>
                            <Input type="text" name="identifier" id="identifierField" className={`form-control-user ${this.hasErrorField('identifier') ? 'is-invalid form-control-danger' : ''}`} onChange={this.handleChange} placeholder={this.props.intl.formatMessage({ id: 'userLoginIdentifierFillInfo', defaultMessage: 'Fill you personnal identifier' })} value={this.state.identifier} autoFocus />
                        </FormGroup>
                        <FormGroup>
                            <Toggle
                                id="rememberMyDeviceField"
                                name="rememberMyDevice"
                                checked={this.state.rememberMyDevice}
                                onChange={this.handleChange}
                            />
                            <Label for="rememberMyDeviceField" className="ps-2 align-text-bottom"><FormattedMessage id="userLoginRememberMyDevice" defaultMessage="Remember my identifier on this device?" /></Label>
                        </FormGroup>
                    </Form>
                )}

                {this.state.step === 'password' && (
                    <Form onSubmit={this.handleLogin}>
                        <p className="text-center">
                            <FormattedMessage id="userLoginIdentifierSelected" defaultMessage="Login with identifier:" /> <strong>{this.state.identifier }</strong><br />
                            <Button color="link" size="sm" onClick={this.handleClearIdentifier}><FontAwesomeIcon icon="times-circle" /> <FormattedMessage id="cancel" defaultMessage="Cancel" /></Button>
                            {this.state.isUnknowUser && (
                                <small>
                                    <br />
                                    <FontAwesomeIcon icon="info-circle" /> <FormattedMessage id="userLoginUnknowUser" defaultMessage="Make sure to log in with the username you received when you were summoned." />
                                </small>
                            )}
                        </p>

                        {this.state.displayAccountCheckError && (
                            <Alert color="danger" className="text-center">
                                <strong><FontAwesomeIcon icon="exclamation-circle" /> <FormattedMessage id="userAccountMismatchError2" defaultMessage="You intempt to log in with distinct account of your convocation. Please check your identifier!" /></strong>
                            </Alert>
                        )}

                        {
                            this.state.isBlocked
                            ? (
                                <Alert color="warning" className="text-center">
                                    <FormattedMessage id="userLoginBlockedAlert" defaultMessage="Please wait a few moments before you can try to log in again..." />
                                </Alert>
                            ) : (
                                <FormGroup>
                                    <InputGroup>
                                        <Label for="passwordField" className="d-none"><FormattedMessage id="userPassword" defaultMessage="Password" /></Label>
                                        <Input type={this.state.displayClearPassword ? 'text' : 'password'} name="password" id="passwordField" className={`${this.hasErrorField('password') ? 'is-invalid form-control-danger' : ''}`} onChange={this.handleChange} placeholder={this.props.intl.formatMessage({ id: 'userPassword', defaultMessage: 'Fill your password' })} value={this.state.password} disabled={this.state.isOnLogin} autoFocus />
                                        <Button color="secondary" outline={!this.state.displayClearPassword} onClick={() => this.setState({ displayClearPassword: !this.state.displayClearPassword })}><FontAwesomeIcon icon={this.state.displayClearPassword ? 'eye-slash' : 'eye'} /></Button>
                                    </InputGroup>
                                </FormGroup>
                            )
                        }
                    </Form>
                )}

                {this.state.step === 'activation' && (
                    <div className="text-center">
                        <Alert color="light">
                            <h4><FontAwesomeIcon icon="shield-halved" /> <FormattedMessage id="userLoginActivationTitle" defaultMessage="Account activation" /></h4>
                            <strong><FormattedMessage id="userLoginAuthenticationUpdateAlert" defaultMessage="The Managexam solution is evolving and strengthening its identification system. Please activate your account by following the instructions below:" /></strong>
                        </Alert>
                        <p>
                            <FontAwesomeIcon icon="info-circle" /> <FormattedMessage id="userLoginFirstText" defaultMessage="Check your mailbox to get your activation link and click it to activate your account. You can later change your password." />
                        </p>
                        <p>
                            <em className="text-warning">
                                <FormattedMessage id="userLoginFirstText2" defaultMessage="Please only take into account the last email received in case of multiple account activation attempts." />
                            </em>
                        </p>
                        {this.state.activation && (
                            <div className="mt-3">
                                <span className="d-none d-lg-inline-block h4 text-primary text-info">
                                    <Chrono date={this.state.activation.end} />
                                </span>
                                <br />
                                <FormattedMessage id="userAuthActivationEndDateAlert" defaultMessage="You have until {date} to activate your account!" values={{ date: dateFormat(this.state.activation.end) }} />
                            </div>
                        )}
                        {/* <ButtonGroup size="sm" className="my-2">
                            <Button color="secondary" outline onClick={() => this.setState({ step: 'identifier' })}><FontAwesomeIcon icon="chevron-left" /> <FormattedMessage id="back" defaultMessage="Back" /></Button>
                            <Button color="info" onClick={() => this.setState({ step: 'password' })}><FontAwesomeIcon icon="check" /> <FormattedMessage id="userPasswordTemporaryCheckButton" defaultMessage="I well received my temporary password" /></Button>
                        </ButtonGroup> */}
                    </div>
                )}

                {this.state.step === 'verification' && (
                    <UserVerificationCheck identifier={this.state.identifier} verification={this.state.verification} onValidation={this.state.hasForgottenPassword ? this.handleForgottenPassword : this.handleLoginWithVerification} skipValidation />
                )}

                <FormGroup>
                    <ButtonGroup className="w-100" aria-label="Actions de connexion">
                        {this.props.closeForm && <Button color="light" onClick={event => this.props.closeForm()}><FontAwesomeIcon icon="chevron-left" /> <span className="d-none d-sm-inline"><FormattedMessage id="back" defaultMessage="Back" /></span></Button>}
                        {this.state.step === 'identifier' && <Button color="success" disabled={!(this.state.userHash || this.state.identifier)} onClick={this.handleCheckAccount} id="loginButton"><FormattedMessage id="next" defaultMessage="Next" /> <FontAwesomeIcon icon="arrow-circle-right" /></Button>}
                        {this.state.step === 'password' && !this.state.isBlocked && <Button color="success" disabled={!(this.state.userHash || this.state.identifier) || !this.state.password || this.state.isOnLogin} onClick={this.handleLogin}><FontAwesomeIcon icon={this.state.isOnLogin ? 'spinner' : 'power-off'} spin={this.state.isOnLogin} /> <FormattedMessage id="userLoginAction" defaultMessage="Login" /></Button>}
                    </ButtonGroup>
                    {/* this.state.displayForgotPasswordButton && */ this.state.isAccountActivated && <Button color="link" size="sm" className="d-inline-block w-100" onClick={() => this.handleForgotPassword()}><FontAwesomeIcon icon="unlock" /> <span className="d-none d-sm-inline"><FormattedMessage id="userForgotPassword" defaultMessage="Forgot password?" /></span></Button>}

                    {process.env.NODE_ENV === 'development' && (
                        <ButtonGroup aria-label="Boutons de développement">
                            <Button onClick={() => this.setState({ identifier: 'clement@offaxis.io' })}>clement@offaxis.io</Button>
                            <Button onClick={() => this.setState({ password: 'Azerty@123456!' })}>password test</Button>
                            {process.env.USER_DEV_PASSWORD && <Button onClick={() => this.setState({ password: process.env.USER_DEV_PASSWORD })}>password admin</Button>}
                        </ButtonGroup>
                    )}
                </FormGroup>

                {!['activation', 'verification'].includes(this.state.step) && (
                    <div className="">
                        <span id="app-legal-data-treatment-toggler" onClick={() => this.setState({ displayDataTreatmentLegalInfo: !this.state.displayDataTreatmentLegalInfo })}><FontAwesomeIcon icon="info-circle" /> <FormattedMessage id="appLegalDataTreatment1" defaultMessage="Managexam processes the collected data as a subcontractor so that you can use our features. To learn more about the management of your personal data and to exercise your rights, please click here" /></span>
                        {this.state.displayDataTreatmentLegalInfo && (
                            <div className="mt-2 p-2 border border-1 rounded-3">
                                <FormattedMessage id="appLegalDataTreatment2" defaultMessage="The data collected will be communicated to the following recipients only: technical department, institution. \nYou can access your data, rectify it, request its deletion or exercise your right to limit the processing of your data.\n Visit the cnil.fr website for more information on your rights.\n To exercise these rights or for any questions about the processing of your data in this system, you can contact our data protection officer at dpo@managexam.com\n If you believe, after contacting us, that your 'Data Protection' rights have not been respected, you can file a complaint with the CNIL.\n More details in our privacy policy" />
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

function mapStateToProps(store, props) {
    return {
        intl: store.intl,
        appRedirect: store.app.redirect,
    };
}

UserLoginForm.defaultProps = {
    appRedirect: '',
    redirect: '',
    closeForm: null,
    onLogin: null,
};

UserLoginForm.propTypes = {
    location: PropTypes.object.isRequired,
    search: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    redirect: PropTypes.string,
    appRedirect: PropTypes.string,
    closeForm: PropTypes.func,
    onLogin: PropTypes.func,
};

export default connect(mapStateToProps)(withRouter(withIntl(UserLoginForm)));
